<template>
    <div>
        <!-- Modal -->
        <modal-add-ontop-package
            :modelValue.sync="isDialogVisible"
            :modalMode="modalMode"
        >
            <template #btn-confirm>
                <el-button data-testid="btnConfirmAlert" type="primary" @click="handleModalSubmit"
                    >Comfirm</el-button
                >
            </template>
        </modal-add-ontop-package>

        <!-- WorkSpace -->
        <div class="current-bill-cycle-container">
            <div
                class="current-bill-cycle-title"
                data-testid="lblCurrentBillCycle"
            >
                Current Bill Cycle
            </div>

            <el-form
                class="current-bill-cycle-form-container"
                label-position="top-left"
                @submit.native.prevent
            >
                <el-row>
                    <el-col :span="20">
                        <el-row :gutter="40">
                            <el-col :span="12">
                                <el-form-item >
                                    <template #label>
                                        <label data-testid="lblCurPackage">Current Package</label>
                                    </template>
                                    <el-input
                                        readonly
                                        type="text"
                                        data-testid="txtCurPackage"
                                        :value="
                                            convertEnumCode(
                                                propsCurrentBillCycle.currentPackageCode
                                            )
                                        "
                                    />
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item>
                                    <template #label>
                                        <label data-testid="lblOrdPackage">Order Package</label>
                                    </template>
                                    <el-input
                                            readonly
                                            type="text"
                                            data-testid="txtOrdPackage"
                                            :value="
                                                propsCurrentBillCycle.orderPackage
                                                    | currency('', ',', 0)
                                            "
                                        />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-row :gutter="40">
                            <el-col :span="12">
                                <el-form-item>
                                    <template #label>
                                        <label data-testid="lblStartDate">Start Date</label>
                                    </template>
                                    <el-input
                                        readonly
                                        type="text"
                                        data-testid="txtStartDate"
                                        :value="
                                        propsCurrentBillCycle.startDate ?
                                            $dayjs(
                                                propsCurrentBillCycle.startDate
                                            ).format('YYYY-MM-DD') : ''"
                                    />
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item>
                                    <template #label>
                                        <label data-testid="lblEndDate">End Date</label>
                                    </template>
                                    <el-input
                                        readonly
                                        type="text"
                                        data-testid="txtEndDate"
                                        :value="
                                            propsCurrentBillCycle.endDate ?
                                            $dayjs(
                                                propsCurrentBillCycle.endDate
                                            ).format('YYYY-MM-DD') : ''"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item>
                                    <el-table
                                        :data="propsCurrentBillCycle.ontopList"
                                        :header-cell-style="{
                                            'background-color': 'black',
                                            color: 'white',
                                            'font-size': '14px',
                                            'font-weight': '500'
                                        }"
                                        stripe
                                        data-testid="tblOntopPackage"
                                    >
                                        <el-table-column
                                            type="index"
                                            label="No."
                                            width="70"
                                            align="left"
                                            data-testid="tblOntopPackageCell"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                            prop="packageCode"
                                            label="Package Type"
                                            align="left"
                                        >
                                            <template slot-scope="scope">{{
                                                scope.row.packageCode ?
                                                convertEnumCode(
                                                    scope.row.packageCode
                                                ) : ''
                                            }}</template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="orderPackage"
                                            label="Order Package"
                                            align="left"
                                        >
                                            <template slot-scope="scope">{{
                                                scope.row.orderPackage
                                                    | currency("", ",", 0)
                                            }}</template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="ontopDate"
                                            label="Ontop Date"
                                            align="left"
                                        >
                                            <template slot-scope="scope">{{
                                                scope.row.ontopDate
                                                    ? $dayjs(
                                                          scope.row.ontopDate
                                                      ).format(
                                                          "YYYY-MM-DD HH:mm:ss"
                                                      )
                                                    : ""
                                            }}</template>
                                        </el-table-column>
                                        <el-table-column
                                            label="Action"
                                            width="100"
                                            align="left"
                                        >
                                            <template slot-scope="scope">
                                                <el-button
                                                    type="danger"
                                                    plain
                                                    @click="
                                                        handleOntopModal(
                                                            'delete',
                                                            scope.$index
                                                        )
                                                    "
                                                    :data-testid="
                                                        `lnkEdit-${scope.$index +
                                                            1}`
                                                    "
                                                >
                                                    <i
                                                        class="el-icon-delete"
                                                    ></i>
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!-- <div class="table-footer">
                                        <div class="inside-container">
                                            <el-button
                                                :disabled="!propsCurrentBillCycle.currentPackageCode && !propsCurrentBillCycle.orderPackage"
                                                type="primary"
                                                data-testid="btnAddOntopPck"
                                                @click="
                                                    handleOntopModal(
                                                        'add',
                                                        null
                                                    )
                                                "
                                            >
                                                Add OnTop
                                            </el-button>
                                        </div>
                                    </div>-->
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <hr class="current-bill-cycle-line" />
                <el-row>
                    <el-col :span="20">
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item>
                                    <template #label>
                                        <label data-testid="lblTotalOrder">Total Order</label>
                                    </template>
                                    <el-input
                                            readonly
                                            type="text"
                                            data-testid="txtTotalOrder"
                                            :value="
                                                totalOrder
                                                    | currency('', ',', 0)
                                            "
                                        />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item>
                                    <template #label>
                                        <label data-testid="lblOrderUsed">Order Used</label>
                                    </template>
                                    <el-input
                                        readonly
                                        type="text"
                                        data-testid="txtOrderUsed"
                                        :value="
                                            propsCurrentBillCycle.orderUsed
                                                | currency('', ',', 0)
                                        "
                                    />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item>
                                    <template #label>
                                        <label data-testid="lblOrderRemaining">Order Remaining</label>
                                    </template>
                                   <el-input
                                        readonly
                                        type="text"
                                        data-testid="txtOrderRemaining"
                                        :value="
                                            orderRemaining
                                                | currency('', ',', 0)
                                        "
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
            </el-form>
        </div>
    </div>
</template>
<script>
import { packageCode as enumPackageCode } from '../../../constant/subscription'
import ModalAddOntopPackage from './ModalAddOntopPackage.vue'

export default {
    name: 'CurrentBillCycle',
    components: { ModalAddOntopPackage },
    props: {
        propsCurrentBillCycle: {
            type: Object,
            default: () => {
                return {
                    currentPackageCode: '',
                    orderPackage: 0,
                    startDate: '',
                    endDate: '',
                    ontopList: [],
                    orderUsed: 0
                }
            }
        }
    },
    data () {
        return {
            // FLAG
            isDialogVisible: false,
            modalMode: null,
            positionDelete: null,
            totalOrder: 0,
            orderRemaining: 0
        }
    },
    methods: {
        // Function
        addOntopItem () {
            this.propsCurrentBillCycle.ontopList.push({
                packageCode: this.propsCurrentBillCycle.currentPackageCode,
                orderPackage: parseInt(this.propsCurrentBillCycle.orderPackage)
            })
            this.clearModalFlag()
        },
        deleteOntopItem () {
            this.propsCurrentBillCycle.ontopList.splice(this.positionDelete, 1)
            this.clearModalFlag()
        },
        convertEnumCode (code) {
            return enumPackageCode[code]
        },
        handleOntopModal (mode, index) {
            this.modalMode = mode
            this.positionDelete = index
            this.isDialogVisible = true
        },
        handleModalSubmit () {
            if (this.modalMode === 'add') {
                return this.addOntopItem()
            } else if (this.modalMode === 'delete') {
                return this.deleteOntopItem()
            }
        },
        // Utils
        clearModalFlag () {
            this.modalMode = null
            this.positionDelete = null
            this.isDialogVisible = false
        }
    },
    watch: {
        'propsCurrentBillCycle.ontopList' (value) {
            let sumArr = value.map(thing => parseInt(thing.orderPackage)).reduce((cur, acc) => cur + acc, 0)
            this.totalOrder = this.propsCurrentBillCycle.orderPackage + sumArr
            this.orderRemaining = this.propsCurrentBillCycle.orderPackage + (sumArr - parseInt(this.propsCurrentBillCycle.orderUsed))
        }
    },
    created () {
        const sumInitailOntopList = this.propsCurrentBillCycle.ontopList
            .map(thing => parseInt(thing.orderPackage))
            .reduce((cur, acc) => cur + acc, 0)

        this.totalOrder = this.propsCurrentBillCycle.orderPackage + sumInitailOntopList
        this.orderRemaining = this.propsCurrentBillCycle.orderPackage + (sumInitailOntopList - this.propsCurrentBillCycle.orderUsed)
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-row {
    margin-bottom: 0 !important;
}

::v-deep .el-input .el-input__inner {
    color: #000000;
    border: 1px solid #DCDFE6;
    background: #F9FAFC;
    opacity: 1 !important;
}

::v-deep .el-form-item{
    margin-bottom: 10px;
}

::v-deep .el-table {
    margin-top: 10px;
    color: #000000;
    opacity: 1 !important;

    &::before{
        background-color: transparent;
    }

    th {
        padding: 0;
    }

    td {
        border-bottom: none;
    }
}

::v-deep .el-button--danger.is-plain{
    padding: 10px 17px;
}

.current-bill-cycle-container {
    margin-left: 50px;
}

.current-bill-cycle-form-container{
    min-width: 700px;
}

.current-bill-cycle-title {
    font-size: 16px;
    color: #000000;
    font-weight: 500;
    text-align: left;
    margin-bottom: 16px;
}

.current-bill-cycle-line {
    border: 1px dashed #DCDFE6
}

.table-footer {
    padding: 12px;
    border-top: none;
    display: flex;
    justify-content: flex-end;
    color: #000000;

    .inside-container {
        display: flex;
        align-items: center;
    }
}
</style>
